import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ 
  title, 
  description, 
  canonicalPath,
  ogImage,
  ogType = 'website',
  structuredData 
}) => {
  const location = useLocation();
  const currentLang = location.pathname.startsWith('/de') ? 'de' : 'en';
  const baseUrl = 'https://podcastzurich.com';
  
  useEffect(() => {
    // Update document title
    if (title) {
      document.title = title;
    }
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink && canonicalPath) {
      canonicalLink.setAttribute('href', `${baseUrl}${canonicalPath}`);
    }
    
    // Update hreflang tags
    const enHreflang = document.querySelector('link[hreflang="en"]');
    const deHreflang = document.querySelector('link[hreflang="de"]');
    const defaultHreflang = document.querySelector('link[hreflang="x-default"]');
    
    if (canonicalPath) {
      const enPath = canonicalPath.replace('/de', '/en');
      const dePath = canonicalPath.replace('/en', '/de');
      
      if (enHreflang) enHreflang.setAttribute('href', `${baseUrl}${enPath}`);
      if (deHreflang) deHreflang.setAttribute('href', `${baseUrl}${dePath}`);
      if (defaultHreflang) defaultHreflang.setAttribute('href', `${baseUrl}${enPath}`);
    }
    
    // Update Open Graph tags
    const ogTitleMeta = document.querySelector('meta[property="og:title"]');
    const ogDescMeta = document.querySelector('meta[property="og:description"]');
    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
    const ogImageMeta = document.querySelector('meta[property="og:image"]');
    const ogTypeMeta = document.querySelector('meta[property="og:type"]');
    const ogLocaleMeta = document.querySelector('meta[property="og:locale"]');
    
    if (ogTitleMeta && title) ogTitleMeta.setAttribute('content', title);
    if (ogDescMeta && description) ogDescMeta.setAttribute('content', description);
    if (ogUrlMeta && canonicalPath) ogUrlMeta.setAttribute('content', `${baseUrl}${canonicalPath}`);
    if (ogImageMeta && ogImage) ogImageMeta.setAttribute('content', ogImage);
    if (ogTypeMeta) ogTypeMeta.setAttribute('content', ogType);
    if (ogLocaleMeta) ogLocaleMeta.setAttribute('content', currentLang === 'de' ? 'de_CH' : 'en_US');
    
    // Update Twitter tags
    const twitterTitleMeta = document.querySelector('meta[property="twitter:title"]');
    const twitterDescMeta = document.querySelector('meta[property="twitter:description"]');
    const twitterUrlMeta = document.querySelector('meta[property="twitter:url"]');
    const twitterImageMeta = document.querySelector('meta[property="twitter:image"]');
    
    if (twitterTitleMeta && title) twitterTitleMeta.setAttribute('content', title);
    if (twitterDescMeta && description) twitterDescMeta.setAttribute('content', description);
    if (twitterUrlMeta && canonicalPath) twitterUrlMeta.setAttribute('content', `${baseUrl}${canonicalPath}`);
    if (twitterImageMeta && ogImage) twitterImageMeta.setAttribute('content', ogImage);
    
    // Update HTML lang attribute
    document.documentElement.lang = currentLang;
    
    // Update page-specific structured data
    if (structuredData) {
      // Remove existing page-specific structured data
      const existingPageSchemas = document.querySelectorAll('script[data-page-schema]');
      existingPageSchemas.forEach(schema => schema.remove());
      
      // Handle both single objects and arrays of structured data
      const dataArray = Array.isArray(structuredData) ? structuredData : [structuredData];
      
      dataArray.forEach((data, index) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-page-schema', 'true');
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
      });
    }
    
  }, [title, description, canonicalPath, ogImage, ogType, structuredData, currentLang]);
  
  return null;
};

export default SEOHead;
